/**
 * @file capitalizeFirst.ts
 * @brief The first letter a person types is a capital, on every field (DES
 *        12-10-2026: "pehlay word", not every word; the phone's keyboard
 *        does this as you type, a desktop keyboard never does).
 *
 * Only ADDS a capital, to the first letter of the text (after any leading
 * spaces); nothing else changes, so "iPhone" typed later in a sentence and
 * "McDonald" keep theirs. Scripts without case (Urdu, Arabic) come back
 * unchanged. Applied as the first letter is typed (notes) or when a field is
 * left (Input `capitalizeFirst`), never per key elsewhere, so the caret never
 * jumps.
 *
 * @references components/ui/Input.tsx, features/notes (points, titles)
 * @author DES
 * @date 12-10-2026
 */

export function capitalizeFirst(text: string): string {
  if (!text) return text;
  return text.replace(/^(\s*)(\p{Ll})/u, (_m, lead: string, ch: string) => lead + ch.toLocaleUpperCase());
}
